import * as types from '../types/access'

/**
 * The logged-in user's Alfred access, from GET /base/me (`alfred_access`).
 *
 *   access = { role, unrestricted, permissions[] }
 *
 * `loaded` gates the first paint: until /base/me answers we know nothing, and
 * rendering the sidebar/routes against an empty permission list would flash an
 * empty app (or bounce the user off the page they asked for). Gates render a
 * spinner while this is false.
 */
const UNRESTRICTED = { role: null, unrestricted: true, permissions: [] }

const initialState = {
  loaded: false,
  access: null
}

export const accessReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_ACCESS:
      return { ...state, loaded: false }

    case types.FETCH_ACCESS_SUCCESS:
      return { loaded: true, access: action.access || UNRESTRICTED }

    // Fail OPEN, deliberately. If /base/me is down we must not lock an admin out
    // of the entire portal — roles hide UI, they are not a security boundary, so
    // the safe failure is to show everything (which is also what a user with no
    // role sees anyway). Failing closed would turn one flaky request into a
    // total outage of the admin tool.
    case types.FETCH_ACCESS_FAILED:
      return { loaded: true, access: UNRESTRICTED }

    default:
      return state
  }
}
